// The texts of Step 5 (the document page, Approved as is, the discrepancy types, Link to an order, Settings, Upload and onboarding), English and Italian. Merged into en.js and it.js.

export const step5En = {
  'doc.title.po': 'Purchase order',
  'doc.title.confirmation': 'Order confirmation',
  'doc.title.ddt': 'Delivery note',
  'doc.title.packing_list': 'Packing list',
  'doc.title.invoice': 'Invoice',
  'doc.title.generic': 'Document',
  'doc.pill.po': 'Order',
  'doc.pill.confirmation': 'Confirmation',
  'doc.pill.ddt': 'Delivery note',
  'doc.pill.packing_list': 'Packing list',
  'doc.pill.invoice': 'Invoice',
  'doc.formatted': 'Formatted',
  'doc.original': 'Original',
  'doc.download': 'Export PDF',
  'doc.downloadFailed': 'The file could not be downloaded. Try again.',
  'doc.backToCase': 'Back to the case',
  'doc.empty': 'This case has no documents yet.',
  'doc.noOriginal': 'There is no original file for this document.',
  'doc.originalFailed': 'The original file could not be loaded. Try again.',
  'doc.loadingOriginal': 'Loading the original…',
  'doc.supplier': 'Supplier',
  'doc.customer': 'Customer',
  'doc.date': 'Date',
  'doc.currency': 'Currency',
  'doc.linkedPo': 'Linked order',
  'doc.total': 'Total',
  'doc.flagged': 'This document is flagged.',
  'doc.openCase': 'Open the case',
  'doc.viewer.prev': 'Previous page',
  'doc.viewer.next': 'Next page',
  'doc.viewer.zoomIn': 'Zoom in',
  'doc.viewer.zoomOut': 'Zoom out',
  'doc.viewer.download': 'Download',
  'doc.viewer.error': 'This file could not be shown here. Use Download to open it.',
  'ask.title': 'Ask Floxir',
  'ask.clear': 'Clear conversation',
  'ask.collapse': 'Collapse',
  'ask.you': 'You',
  'ask.floxir': 'Floxir',
  'ask.mic': 'Speak',
  'ask.field': 'Ask',
  'ask.placeholder': 'Ask or type a question…',
  'ask.send': 'Send',
  'ask.languages': 'Ask in Italian or English',
  'ask.noAnswer': 'I could not find an answer to that.',
  'ask.state.idle': 'Tap the mic to speak, or type below',
  'ask.state.listening': 'Listening… tap to stop',
  'ask.state.thinking': 'Thinking…',
  'ask.state.speaking': 'Speaking… tap to interrupt',
  'ask.err.generic': 'Ask could not answer just now. Try again.',
  'ask.err.tooMany': 'Too many questions in a minute. Wait a moment.',
  'ask.err.unavailable': 'Ask is not available right now.',
  'ask.err.mic': 'The microphone could not be used. Check the permission, or type your question.',
  'ask.err.transcribe': 'I could not hear that. Try again, or type your question.',
  'ask.tile.attention': 'Needs attention',
  'ask.tile.open': 'Open',
  'ask.tile.matched': 'Matched',
  'ask.tile.done': 'Done',
  'ask.open': 'Open: {what}',
  'ask.request': 'Open the request for {label}',
  'ask.card.title': 'Approve case {label} as is?',
  'ask.card.body': 'The difference is recorded as accepted, not as recovered. Nothing happens until you click Approve.',
  'ask.card.approve': 'Approve',
  'ask.card.cancel': 'Not now',
  'ask.card.done': 'Approved. {label} is Done.',
  'ask.card.undo': 'Undo',
  'ask.card.undone': 'Undone. The case is open again.',
  'ask.card.dismissed': 'Nothing was approved.',
  'ask.card.err.permission': 'You do not have permission to decide on cases.',
  'ask.card.err.used': 'This card was already used. Ask again.',
  'ask.card.err.expired': 'This card expired. Ask again.',
  'ask.card.err.closed': 'This case can no longer be approved.',
  'ask.card.err.failed': 'That did not work. Nothing was changed. Try again.',
  'set.title': 'Settings',
  'set.back': 'Back',
  'set.profile': 'Your profile',
  'set.email': 'Email',
  'set.name': 'Your name',
  'set.name.save': 'Save',
  'set.name.saved': 'Saved',
  'set.name.failed': 'Your name could not be saved. Try again.',
  'set.help': 'Help',
  'set.help.email': 'Support email',
  'set.help.phone': 'Support phone',
  'set.changePassword': 'Change password',
  'set.passwordSent': 'If that email has an account, a link to set a new password is on its way. Check your inbox.',
  'set.passwordFailed': 'The email could not be sent. Try again.',
  'set.signOut': 'Sign out',
  'set.company': 'Your company',
  'set.companyName': 'Company name',
  'set.baseCurrency': 'Base currency',
  'set.baseCurrency.note': 'Every report is in this currency, so changing it changes every figure. Floxir sets it with you; ask support to change it.',
  'set.businessType': 'Type of business',
  'set.team': 'Team',
  'set.docsIn': 'Documents in',
  'set.docsIn.help': 'Forward supplier and buyer emails here. Documents arrive on their own.',
  'set.docsIn.error': 'The address could not be read.',
  'set.copy': 'Copy',
  'set.copied': 'Copied',
  'addr.inbound': 'Documents (orders, invoices)',
  'addr.ship': 'Delivery documents',
  'set.more': 'More settings (branding, email options, exports)',
  'set.rates.title': 'Commission rates',
  'set.rates.count': '{n} suppliers with a rate',
  'set.rates.loading': 'Loading…',
  'set.rates.help': 'One rate per supplier, in percent. The suppliers with the most invoices are shown ({n} in all).',
  'set.rates.conflict': 'two different rates on file',
  'set.rates.save': 'Save rates',
  'set.rates.saved': 'Rates saved.',
  'set.rates.failed': 'Some rates could not be saved. Try again.',
  'set.rates.bad': 'A rate is a number from 0 to 100.',
  'set.rates.error': 'The rates could not be read. Try again.',
  'upl.title': 'Upload',
  'upl.back': 'Back to Cases',
  'upl.sub': 'Forward them, drop them here, or import your history',
  'upl.upload': 'Upload',
  'upl.drop': 'Drop PDFs or photos here',
  'upl.choose': 'Choose files',
  'upl.waiting': 'Waiting…',
  'upl.unsupported': 'Only PDFs and photos can be added here.',
  'upl.forward': 'Forward by email',
  'upl.forward.help': 'Anything sent or forwarded to this address is read and filed automatically.',
  'upl.copyAddress': 'Copy address',
  'upl.onboarding': 'Import & onboarding',
  'upl.history': 'Your history',
  'upl.history.hint': 'Documents on file. Import orders, confirmations, deliveries and invoices.',
  'upl.rates': 'Commission rates',
  'upl.rates.hint': 'One rate per supplier',
  'upl.rates.set': '{n} set',
  'upl.rule': 'Forwarding rule',
  'upl.rule.hint': 'New documents arrive on their own',
  'upl.rule.active': 'Active',
  'upl.rule.waiting': 'Waiting for the first email',
  'upl.stock': 'Opening stock and tax setup',
  'upl.stock.hint': 'Distributors and manufacturers only',
  'approved.title': 'Approved as is',
  'approved.text': 'The case no longer needs attention: it is Matched, and Done once its payment term ends. It is recorded as accepted, not as recovered.',
  'approved.textAmount': 'The case no longer needs attention: it is Matched, and Done once its payment term ends. The {amount} difference is recorded as accepted, not as recovered.',
  'approved.undo': 'Undo',
  'approved.back': 'Back to Needs attention',
  'approved.undoFailed': 'The approval could not be undone. Try again.',
  'case.actions.hint.noNumber': 'Ask for a corrected invoice drafts an email to {supplier}. Link to an order links the invoice to one of their orders.',
  'case.action.ask_corrected_invoice': 'Ask for a corrected invoice',
  'case.action.link_order': 'Link to an order',
  'link.title': 'Link this invoice to an order',
  'link.intro': 'Pick one of this supplier\'s orders. The server checks that it is the same supplier and the same company.',
  'link.empty': 'This supplier has no orders on file.',
  'link.search': 'Search this supplier\'s orders by number',
  'link.noMatch': 'No order of this supplier matches "{q}".',
  'link.hasCase': 'Already has a case',
  'link.confirm': 'Link to this order',
  'link.cancel': 'Cancel',
  'link.loading': 'Loading the orders…',
  'link.error': 'The orders could not be read. Try again.',
  'link.err.order_has_case': 'That order already has its own case. Open it from the list instead.',
  'link.err.wrong_supplier': 'That order belongs to another supplier.',
  'link.err.order_not_found': 'That order was not found.',
  'link.err.failed': 'The link could not be made. Try again.',
  'types.title': 'Discrepancy types',
  'types.link': 'Discrepancy types',
  'reports.commissions.earned': 'Earned commission',
  'case.problem.recoveredZeroHint': 'Approved as is: nothing was returned.',
  'set.forecastWeeks.title': 'Open orders expected after',
  'set.forecastWeeks.help': 'In the Forecast, an order with no invoice is expected as commission this many weeks after its date.',
  'set.weeks.unit': 'weeks',
  'set.fxVariance.title': 'Statement tolerance (exchange-rate variance)',
  'set.fxVariance.help': 'When a supplier statement is compared with your invoices, a difference up to this percent counts as agreeing.',
  'set.percent.unit': '%',
  'set.number.bad': 'Enter a number from {min} to {max}.',
  'doc.backToHistory': 'Back to History',
  'today.title': 'Today',
  'today.received': 'Received',
  'today.discrepancies': 'New discrepancies',
  'today.unclassified': 'Unclassified',
  'today.error': "The numbers can't be loaded right now.",
  'today.doc.invoice': 'Invoices',
  'today.doc.purchase_order': 'Orders',
  'today.doc.delivery_note': 'Delivery notes',
  'today.doc.packing_list': 'Packing lists',
  'today.doc.packing_slip': 'Packing slips',
  'today.doc.quote': 'Quotes',
  'today.doc.receipt': 'Receipts',
  'today.doc.credit_note': 'Credit notes',
  'today.doc.payment_confirmation': 'Payment confirmations',
  'today.problem.price_higher': 'Price differs',
  'today.problem.extra_charge': 'Extra charge',
  'today.problem.qty_short': 'Delivered less',
  'today.problem.qty_over': 'Delivered more',
  'today.problem.billed_over_delivered': 'Billed above delivered',
  'today.problem.duplicate': 'Duplicate invoice',
  'today.problem.duplicate_invoice': 'Duplicate invoice',
  'today.problem.vat_error': 'VAT error',
  'today.problem.order_missing': 'Order missing',
  'cases.hist.tab.documents': 'Documents',
  'cases.hist.tab.unclassified': 'Unclassified ({n})',
  'cases.hist.filter.noCase': 'No case',
  'cases.hist.emptyNoCase': 'No documents without a case.',
  'cases.hist.since': 'Since {day}',
  'cases.hist.since.clear': 'Show all days',
  'unc.title': 'Unclassified documents',
  'unc.help': 'Floxir read these but could not tell what they are. Choose what a document is, or say it is not a document.',
  'unc.empty': 'No unclassified documents.',
  'unc.error': "The documents can't be loaded right now.",
  'unc.from': 'From {from}',
  'unc.noSender': 'Sender not known',
  'unc.received': 'Received {day}',
  'unc.noText': 'No text could be read (a scanned file). Open the original to see it.',
  'unc.open': 'Open original',
  'unc.setType': 'Set type',
  'unc.notDoc': 'Not a document',
  'unc.type.order': 'Order',
  'unc.type.invoice': 'Invoice',
  'unc.type.delivery_note': 'Delivery note',
  'unc.type.packing_list': 'Packing list',
  'unc.type.label': 'This document is a',
  'unc.type.choose': 'Choose a type',
  'unc.type.note': 'Floxir will read this document again as “{type}” and process it. This takes a moment, and your name is recorded.',
  'unc.type.go': 'Read again',
  'unc.type.busy': 'Reading the document again…',
  'unc.type.done': 'Read again and processed. It has left this list.',
  'unc.type.failed': 'Could not read it again. Nothing was changed.',
  'unc.notDoc.note': 'This document is kept, but it leaves this list. Your name is recorded.',
  'unc.notDoc.go': 'Yes, not a document',
  'unc.notDoc.done': 'Moved out of this list.',
  'unc.notDoc.failed': 'Could not do that. Nothing was changed.',
  'unc.cancel': 'Cancel',
  'unc.more': 'Show more',
  'unc.fileError': "The original can't be opened right now.",
  'set.late.title': 'Order stays open for',
  'set.late.help': 'How long an order may wait for its invoice. After that time the case moves to Needs attention as Documents late. Switch it off and it never does.',
  'set.late.unit': 'Unit',
  'set.late.unit.days': 'days',
  'set.late.unit.weeks': 'weeks',
  'set.late.offLabel': 'Off',
  'set.late.off': 'Off',
  'set.late.days': '{n} days',
  'set.late.weeks': '{n} weeks',
  'set.late.save': 'Save',
  'set.late.saved': 'Saved',
  'set.late.failed': 'Could not save. Try again.',
  'set.late.bad': 'Enter a whole number of days or weeks (up to 2 years).',
  'search.archived': 'Archived',
  'ask.tile.case': 'Case',
  'set.floxirEmail': 'Floxir email',
  'approved.accepted': 'Accepted',
  'needs.row.documents_late': 'Documents late',
  'types.intro': 'Every kind of difference Floxir can show on a case. The ones it finds today are listed by group; the others are listed apart, not yet detected.',
  'types.group.order': 'Order and confirmation',
  'types.group.delivery': 'Delivery',
  'types.group.payment': 'Payment and disputes',
  'types.group.invoice': 'Invoice',
  'types.notDetected': 'Not detected yet',
  'types.notDetected.hint': 'Floxir does not find these differences yet. They are listed so you can see what is planned.',
  'types.back': 'Back to Cases',
  'types.doThis': 'What you can do',
  'types.action.request_order': 'Request order',
  'types.action.create_from_invoice': 'Create from invoice',
  'types.action.ask_corrected_invoice': 'Ask for a corrected invoice',
  'types.action.link_order': 'Link to an order',
  'types.action.confirm_order': 'Confirm the suggested order',
  'types.action.request_correction': 'Request correction',
  'types.action.approve': 'Approve as is',
  'types.action.not_duplicate': 'Not a duplicate',
  'types.error': 'The list could not be read. Try again.',
  'type.confirmation_differs': 'Confirmation differs from the order',
  'type.confirmation_differs.text': 'The supplier\'s confirmation has a price or quantity that is not on the order.',
  'type.order_missing': 'Order missing',
  'type.order_missing.text': 'The invoice names an order that never arrived, so nothing on it can be checked.',
  'type.no_order_number': 'No order number on the invoice',
  'type.no_order_number.text': 'The invoice does not say which order it belongs to. Ask for it again, or link it to an order.',
  'type.delivered_less': 'Delivered less than ordered',
  'type.delivered_less.text': 'Less arrived than was ordered; the rest of the order is still open.',
  'type.delivered_more': 'Delivered more than ordered',
  'type.delivered_more.text': 'More arrived than was ordered. Accept the extra or send it back.',
  'type.delivery_note_differs': 'Delivery note differs from packing list',
  'type.delivery_note_differs.text': 'One of the two supplier documents is wrong.',
  'type.short_payment': 'Short payment',
  'type.short_payment.text': 'A customer paid less than was invoiced.',
  'type.paid_twice': 'Paid twice',
  'type.paid_twice.text': 'The same invoice was paid two times.',
  'type.customer_dispute': 'Customer dispute',
  'type.customer_dispute.text': 'A customer says goods arrived damaged or missing.',
  'type.price_above_order': 'Price above order',
  'type.price_above_order.text': 'The invoice price is above the agreed order price.',
  'type.billed_above_ordered': 'Billed above ordered',
  'type.billed_above_ordered.text': 'The invoice has more quantity than the order.',
  'type.billed_above_delivered': 'Billed above delivered',
  'type.billed_above_delivered.text': 'The invoice bills more than the delivery note says arrived.',
  'type.charge_not_ordered': 'Charge not ordered',
  'type.charge_not_ordered.text': 'A charge (freight, a fee) is billed that was never on the order.',
  'type.missing_line_item': 'Missing line item',
  'type.missing_line_item.text': 'The invoice bills an article that is not on the order.',
  'type.documents_late': 'Documents late',
  'type.documents_late.text': 'The order has waited longer than the time you set and no invoice has arrived.',
  'type.duplicate_invoice': 'Duplicate invoice',
  'type.duplicate_invoice.text': 'The same invoice was received twice. Paying both would pay twice.',
  'type.item_not_ordered': 'Item not ordered',
  'type.item_not_ordered.text': 'A different article or colour was billed.',
  'type.discount_missing': 'Agreed discount missing',
  'type.discount_missing.text': 'The order has a discount that the invoice does not apply.',
  'type.payment_terms_differ': 'Payment terms differ from the order',
  'type.payment_terms_differ.text': 'The invoice terms are not the ones on the order.',
  'type.totals_dont_add_up': 'Totals don\'t add up',
  'type.totals_dont_add_up.text': 'The lines do not add up to the invoice total.',
  'type.vat_wrong': 'VAT wrong',
  'type.vat_wrong.text': 'The VAT charged is not what applies to this sale.',
  'type.bank_details_changed': 'Bank details changed',
  'type.bank_details_changed.text': 'The bank account on the invoice differs from earlier invoices.',
  'type.price_below_list': 'Price below list',
  'type.price_below_list.text': 'A sale price is under the list price.',
};

export const step5It = {
  'doc.title.po': 'Ordine di acquisto',
  'doc.title.confirmation': 'Conferma d\'ordine',
  'doc.title.ddt': 'Documento di trasporto',
  'doc.title.packing_list': 'Packing list',
  'doc.title.invoice': 'Fattura',
  'doc.title.generic': 'Documento',
  'doc.pill.po': 'Ordine',
  'doc.pill.confirmation': 'Conferma',
  'doc.pill.ddt': 'DDT',
  'doc.pill.packing_list': 'Packing list',
  'doc.pill.invoice': 'Fattura',
  'doc.formatted': 'Formattato',
  'doc.original': 'Originale',
  'doc.download': 'Esporta PDF',
  'doc.downloadFailed': 'Non è stato possibile scaricare il file. Riprova.',
  'doc.backToCase': 'Torna al caso',
  'doc.empty': 'Questo caso non ha ancora documenti.',
  'doc.noOriginal': 'Per questo documento non c\'è un file originale.',
  'doc.originalFailed': 'Non è stato possibile caricare il file originale. Riprova.',
  'doc.loadingOriginal': 'Caricamento dell\'originale…',
  'doc.supplier': 'Fornitore',
  'doc.customer': 'Cliente',
  'doc.date': 'Data',
  'doc.currency': 'Valuta',
  'doc.linkedPo': 'Ordine collegato',
  'doc.total': 'Totale',
  'doc.flagged': 'Questo documento è segnalato.',
  'doc.openCase': 'Apri il caso',
  'doc.viewer.prev': 'Pagina precedente',
  'doc.viewer.next': 'Pagina successiva',
  'doc.viewer.zoomIn': 'Ingrandisci',
  'doc.viewer.zoomOut': 'Riduci',
  'doc.viewer.download': 'Scarica',
  'doc.viewer.error': 'Questo file non può essere mostrato qui. Usa Scarica per aprirlo.',
  'ask.title': 'Chiedi a Floxir',
  'ask.clear': 'Cancella la conversazione',
  'ask.collapse': 'Riduci',
  'ask.you': 'Tu',
  'ask.floxir': 'Floxir',
  'ask.mic': 'Parla',
  'ask.field': 'Chiedi',
  'ask.placeholder': 'Chiedi o scrivi una domanda…',
  'ask.send': 'Invia',
  'ask.languages': 'Chiedi in italiano o in inglese',
  'ask.noAnswer': 'Non ho trovato una risposta.',
  'ask.state.idle': 'Tocca il microfono per parlare, o scrivi qui sotto',
  'ask.state.listening': 'Ti ascolto… tocca per fermare',
  'ask.state.thinking': 'Sto pensando…',
  'ask.state.speaking': 'Parlo… tocca per interrompere',
  'ask.err.generic': 'Al momento non ho potuto rispondere. Riprova.',
  'ask.err.tooMany': 'Troppe domande in un minuto. Aspetta un momento.',
  'ask.err.unavailable': 'Chiedi a Floxir non è disponibile al momento.',
  'ask.err.mic': 'Non è stato possibile usare il microfono. Controlla il permesso, o scrivi la domanda.',
  'ask.err.transcribe': 'Non ho sentito bene. Riprova, o scrivi la domanda.',
  'ask.tile.attention': 'Da controllare',
  'ask.tile.open': 'Aperti',
  'ask.tile.matched': 'Abbinati',
  'ask.tile.done': 'Fatti',
  'ask.open': 'Apri: {what}',
  'ask.request': 'Apri la richiesta per {label}',
  'ask.card.title': 'Approvare il caso {label} così com\'è?',
  'ask.card.body': 'La differenza è registrata come accettata, non come recuperata. Non succede nulla finché non premi Approva.',
  'ask.card.approve': 'Approva',
  'ask.card.cancel': 'Non ora',
  'ask.card.done': 'Approvato. {label} è Fatto.',
  'ask.card.undo': 'Annulla',
  'ask.card.undone': 'Annullato. Il caso è di nuovo aperto.',
  'ask.card.dismissed': 'Non è stato approvato nulla.',
  'ask.card.err.permission': 'Non hai il permesso di decidere sui casi.',
  'ask.card.err.used': 'Questa scheda è già stata usata. Chiedi di nuovo.',
  'ask.card.err.expired': 'Questa scheda è scaduta. Chiedi di nuovo.',
  'ask.card.err.closed': 'Questo caso non può più essere approvato.',
  'ask.card.err.failed': 'Non ha funzionato. Non è stato cambiato nulla. Riprova.',
  'set.title': 'Impostazioni',
  'set.back': 'Indietro',
  'set.profile': 'Il tuo profilo',
  'set.email': 'Email',
  'set.name': 'Il tuo nome',
  'set.name.save': 'Salva',
  'set.name.saved': 'Salvato',
  'set.name.failed': 'Non è stato possibile salvare il nome. Riprova.',
  'set.help': 'Aiuto',
  'set.help.email': 'Email di assistenza',
  'set.help.phone': 'Telefono di assistenza',
  'set.changePassword': 'Cambia password',
  'set.passwordSent': 'Se quell\'email ha un account, un link per impostare una nuova password sta arrivando. Controlla la posta.',
  'set.passwordFailed': 'Non è stato possibile inviare l\'email. Riprova.',
  'set.signOut': 'Esci',
  'set.company': 'La tua azienda',
  'set.companyName': 'Nome azienda',
  'set.baseCurrency': 'Valuta base',
  'set.baseCurrency.note': 'Ogni report è in questa valuta, quindi cambiarla cambia ogni cifra. La imposta Floxir con te; chiedi al supporto di cambiarla.',
  'set.businessType': 'Tipo di attività',
  'set.team': 'Team',
  'set.docsIn': 'Documenti in arrivo',
  'set.docsIn.help': 'Inoltra qui le email di fornitori e clienti. I documenti arrivano da soli.',
  'set.docsIn.error': 'Non è stato possibile leggere l\'indirizzo.',
  'set.copy': 'Copia',
  'set.copied': 'Copiato',
  'addr.inbound': 'Documenti (ordini, fatture)',
  'addr.ship': 'Documenti di consegna',
  'set.more': 'Altre impostazioni (marchio, opzioni email, esportazioni)',
  'set.rates.title': 'Provvigioni',
  'set.rates.count': '{n} fornitori con un\'aliquota',
  'set.rates.loading': 'Caricamento…',
  'set.rates.help': 'Un\'aliquota per fornitore, in percentuale. Sono mostrati i fornitori con più fatture ({n} in tutto).',
  'set.rates.conflict': 'due aliquote diverse registrate',
  'set.rates.save': 'Salva aliquote',
  'set.rates.saved': 'Aliquote salvate.',
  'set.rates.failed': 'Alcune aliquote non sono state salvate. Riprova.',
  'set.rates.bad': 'Un\'aliquota è un numero da 0 a 100.',
  'set.rates.error': 'Non è stato possibile leggere le aliquote. Riprova.',
  'upl.title': 'Carica',
  'upl.back': 'Torna ai Casi',
  'upl.sub': 'Inoltrali, trascinali qui o importa la tua storia',
  'upl.upload': 'Carica',
  'upl.drop': 'Trascina qui PDF o foto',
  'upl.choose': 'Scegli file',
  'upl.waiting': 'In attesa…',
  'upl.unsupported': 'Qui si possono aggiungere solo PDF e foto.',
  'upl.forward': 'Inoltra per email',
  'upl.forward.help': 'Tutto ciò che viene inviato o inoltrato a questo indirizzo viene letto e archiviato automaticamente.',
  'upl.copyAddress': 'Copia indirizzo',
  'upl.onboarding': 'Importazione e avvio',
  'upl.history': 'La tua storia',
  'upl.history.hint': 'Documenti archiviati. Importa ordini, conferme, consegne e fatture.',
  'upl.rates': 'Provvigioni',
  'upl.rates.hint': 'Un\'aliquota per fornitore',
  'upl.rates.set': '{n} impostate',
  'upl.rule': 'Regola di inoltro',
  'upl.rule.hint': 'I nuovi documenti arrivano da soli',
  'upl.rule.active': 'Attiva',
  'upl.rule.waiting': 'In attesa della prima email',
  'upl.stock': 'Giacenza iniziale e imposte',
  'upl.stock.hint': 'Solo distributori e produttori',
  'approved.title': 'Approvato così com\'è',
  'approved.text': 'Il caso non richiede più attenzione: è Corrispondente, e Fatto alla scadenza del pagamento. È registrato come accettato, non come recuperato.',
  'approved.textAmount': 'Il caso non richiede più attenzione: è Corrispondente, e Fatto alla scadenza del pagamento. La differenza di {amount} è registrata come accettata, non come recuperata.',
  'approved.undo': 'Annulla',
  'approved.back': 'Torna a Da controllare',
  'approved.undoFailed': 'Non è stato possibile annullare l\'approvazione. Riprova.',
  'case.actions.hint.noNumber': '"Chiedi una fattura corretta" scrive a {supplier} con la fattura. "Collega a un ordine" la collega a uno dei suoi ordini.',
  'case.action.ask_corrected_invoice': 'Chiedi una fattura corretta',
  'case.action.link_order': 'Collega a un ordine',
  'link.title': 'Collega questa fattura a un ordine',
  'link.intro': 'Scegli uno degli ordini di questo fornitore. Il server controlla che sia lo stesso fornitore e la stessa azienda.',
  'link.empty': 'Questo fornitore non ha ordini archiviati.',
  'link.search': 'Cerca tra gli ordini di questo fornitore per numero',
  'link.noMatch': 'Nessun ordine di questo fornitore corrisponde a "{q}".',
  'link.hasCase': 'Ha già un caso',
  'link.confirm': 'Collega a questo ordine',
  'link.cancel': 'Annulla',
  'link.loading': 'Caricamento degli ordini…',
  'link.error': 'Non è stato possibile leggere gli ordini. Riprova.',
  'link.err.order_has_case': 'Quell\'ordine ha già un caso suo. Aprilo dall\'elenco.',
  'link.err.wrong_supplier': 'Quell\'ordine appartiene a un altro fornitore.',
  'link.err.order_not_found': 'Quell\'ordine non è stato trovato.',
  'link.err.failed': 'Non è stato possibile fare il collegamento. Riprova.',
  'types.title': 'Tipi di discrepanza',
  'types.link': 'Tipi di discrepanza',
  'reports.commissions.earned': 'Provvigione maturata',
  'case.problem.recoveredZeroHint': 'Approvata così com’è: non è stato restituito nulla.',
  'set.forecastWeeks.title': 'Ordini aperti attesi dopo',
  'set.forecastWeeks.help': 'Nella previsione, un ordine senza fattura è atteso come provvigione dopo questo numero di settimane dalla sua data.',
  'set.weeks.unit': 'settimane',
  'set.fxVariance.title': 'Tolleranza degli estratti (variazione del cambio)',
  'set.fxVariance.help': 'Quando un estratto del fornitore è confrontato con le tue fatture, una differenza fino a questa percentuale conta come corrispondente.',
  'set.percent.unit': '%',
  'set.number.bad': 'Inserisci un numero da {min} a {max}.',
  'doc.backToHistory': 'Torna alla cronologia',
  'today.title': 'Oggi',
  'today.received': 'Ricevuti',
  'today.discrepancies': 'Nuove discrepanze',
  'today.unclassified': 'Non classificati',
  'today.error': 'Non riusciamo a caricare i numeri adesso.',
  'today.doc.invoice': 'Fatture',
  'today.doc.purchase_order': 'Ordini',
  'today.doc.delivery_note': 'Documenti di trasporto',
  'today.doc.packing_list': 'Packing list',
  'today.doc.packing_slip': 'Packing slip',
  'today.doc.quote': 'Preventivi',
  'today.doc.receipt': 'Ricevute',
  'today.doc.credit_note': 'Note di credito',
  'today.doc.payment_confirmation': 'Conferme di pagamento',
  'today.problem.price_higher': 'Prezzo diverso',
  'today.problem.extra_charge': 'Costo extra',
  'today.problem.qty_short': 'Consegnato meno',
  'today.problem.qty_over': 'Consegnato di più',
  'today.problem.billed_over_delivered': 'Fatturato più del consegnato',
  'today.problem.duplicate': 'Fattura duplicata',
  'today.problem.duplicate_invoice': 'Fattura duplicata',
  'today.problem.vat_error': 'Errore IVA',
  'today.problem.order_missing': 'Ordine mancante',
  'cases.hist.tab.documents': 'Documenti',
  'cases.hist.tab.unclassified': 'Non classificati ({n})',
  'cases.hist.filter.noCase': 'Senza pratica',
  'cases.hist.emptyNoCase': 'Nessun documento senza pratica.',
  'cases.hist.since': 'Da {day}',
  'cases.hist.since.clear': 'Mostra tutti i giorni',
  'unc.title': 'Documenti non classificati',
  'unc.help': 'Floxir li ha letti ma non ha capito cosa siano. Scegli cos’è un documento, oppure indica che non è un documento.',
  'unc.empty': 'Nessun documento non classificato.',
  'unc.error': 'Non riusciamo a caricare i documenti adesso.',
  'unc.from': 'Da {from}',
  'unc.noSender': 'Mittente non noto',
  'unc.received': 'Ricevuto {day}',
  'unc.noText': 'Nessun testo leggibile (file scansionato). Apri l’originale per vederlo.',
  'unc.open': 'Apri l’originale',
  'unc.setType': 'Imposta il tipo',
  'unc.notDoc': 'Non è un documento',
  'unc.type.order': 'Ordine',
  'unc.type.invoice': 'Fattura',
  'unc.type.delivery_note': 'Documento di trasporto',
  'unc.type.packing_list': 'Packing list',
  'unc.type.label': 'Questo documento è',
  'unc.type.choose': 'Scegli un tipo',
  'unc.type.note': 'Floxir leggerà di nuovo questo documento come «{type}» e lo elaborerà. Ci vuole un momento e il tuo nome viene registrato.',
  'unc.type.go': 'Leggi di nuovo',
  'unc.type.busy': 'Lettura del documento in corso…',
  'unc.type.done': 'Letto di nuovo ed elaborato. Non è più in questo elenco.',
  'unc.type.failed': 'Impossibile rileggerlo. Non è stato cambiato nulla.',
  'unc.notDoc.note': 'Il documento viene conservato ma esce da questo elenco. Il tuo nome viene registrato.',
  'unc.notDoc.go': 'Sì, non è un documento',
  'unc.notDoc.done': 'Spostato fuori da questo elenco.',
  'unc.notDoc.failed': 'Impossibile farlo. Non è stato cambiato nulla.',
  'unc.cancel': 'Annulla',
  'unc.more': 'Mostra altri',
  'unc.fileError': 'Impossibile aprire l’originale adesso.',
  'set.late.title': "L'ordine resta aperto per",
  'set.late.help': 'Quanto tempo un ordine può aspettare la sua fattura. Dopo questo tempo la pratica passa a Da verificare come Documenti in ritardo. Disattivalo e non succede mai.',
  'set.late.unit': 'Unità',
  'set.late.unit.days': 'giorni',
  'set.late.unit.weeks': 'settimane',
  'set.late.offLabel': 'Disattivato',
  'set.late.off': 'Disattivato',
  'set.late.days': '{n} giorni',
  'set.late.weeks': '{n} settimane',
  'set.late.save': 'Salva',
  'set.late.saved': 'Salvato',
  'set.late.failed': 'Impossibile salvare. Riprova.',
  'set.late.bad': 'Inserisci un numero intero di giorni o settimane (fino a 2 anni).',
  'search.archived': 'Archiviato',
  'ask.tile.case': 'Pratica',
  'set.floxirEmail': 'Email Floxir',
  'approved.accepted': 'Accettato',
  'needs.row.documents_late': 'Documenti in ritardo',
  'types.intro': 'Ogni tipo di differenza che Floxir può mostrare su un caso. Quelli che trova oggi sono elencati per gruppo; gli altri sono elencati a parte, non ancora rilevati.',
  'types.group.order': 'Ordine e conferma',
  'types.group.delivery': 'Consegna',
  'types.group.payment': 'Pagamenti e contestazioni',
  'types.group.invoice': 'Fattura',
  'types.notDetected': 'Non ancora rilevati',
  'types.notDetected.hint': 'Floxir non trova ancora queste differenze. Sono elencate per mostrare cosa è previsto.',
  'types.back': 'Torna ai Casi',
  'types.doThis': 'Cosa puoi fare',
  'types.action.request_order': 'Richiedi ordine',
  'types.action.create_from_invoice': 'Crea dalla fattura',
  'types.action.ask_corrected_invoice': 'Chiedi una fattura corretta',
  'types.action.link_order': 'Collega a un ordine',
  'types.action.confirm_order': 'Conferma l\'ordine suggerito',
  'types.action.request_correction': 'Richiedi correzione',
  'types.action.approve': 'Approva così com\'è',
  'types.action.not_duplicate': 'Non è un duplicato',
  'types.error': 'Non è stato possibile leggere l\'elenco. Riprova.',
  'type.confirmation_differs': 'La conferma differisce dall\'ordine',
  'type.confirmation_differs.text': 'La conferma del fornitore ha un prezzo o una quantità che non è nell\'ordine.',
  'type.order_missing': 'Ordine mancante',
  'type.order_missing.text': 'La fattura cita un ordine mai arrivato, quindi non si può controllare nulla.',
  'type.no_order_number': 'Nessun numero d\'ordine in fattura',
  'type.no_order_number.text': 'La fattura non dice a quale ordine appartiene. Chiedila di nuovo, o collegala a un ordine.',
  'type.delivered_less': 'Consegnato meno dell\'ordinato',
  'type.delivered_less.text': 'È arrivato meno di quanto ordinato; il resto dell\'ordine è ancora aperto.',
  'type.delivered_more': 'Consegnato più dell\'ordinato',
  'type.delivered_more.text': 'È arrivato più di quanto ordinato. Accetta l\'extra o rimandalo indietro.',
  'type.delivery_note_differs': 'DDT diverso dalla packing list',
  'type.delivery_note_differs.text': 'Uno dei due documenti del fornitore è sbagliato.',
  'type.short_payment': 'Pagamento parziale',
  'type.short_payment.text': 'Un cliente ha pagato meno di quanto fatturato.',
  'type.paid_twice': 'Pagato due volte',
  'type.paid_twice.text': 'La stessa fattura è stata pagata due volte.',
  'type.customer_dispute': 'Contestazione del cliente',
  'type.customer_dispute.text': 'Un cliente dice che la merce è arrivata danneggiata o mancante.',
  'type.price_above_order': 'Prezzo sopra l\'ordine',
  'type.price_above_order.text': 'Il prezzo in fattura è sopra il prezzo concordato nell\'ordine.',
  'type.billed_above_ordered': 'Fatturato più dell\'ordinato',
  'type.billed_above_ordered.text': 'La fattura ha più quantità dell\'ordine.',
  'type.billed_above_delivered': 'Fatturato più del consegnato',
  'type.billed_above_delivered.text': 'La fattura addebita più di quanto dice il DDT.',
  'type.charge_not_ordered': 'Addebito non ordinato',
  'type.charge_not_ordered.text': 'Viene addebitato un costo (trasporto, commissione) che non era nell\'ordine.',
  'type.missing_line_item': 'Riga mancante',
  'type.missing_line_item.text': 'La fattura addebita un articolo che non è nell\'ordine.',
  'type.documents_late': 'Documenti in ritardo',
  'type.documents_late.text': 'L\'ordine aspetta da più del tempo impostato e non è arrivata nessuna fattura.',
  'type.duplicate_invoice': 'Fattura duplicata',
  'type.duplicate_invoice.text': 'La stessa fattura è stata ricevuta due volte. Pagarle entrambe vorrebbe dire pagare due volte.',
  'type.item_not_ordered': 'Articolo non ordinato',
  'type.item_not_ordered.text': 'È stato fatturato un articolo o un colore diverso.',
  'type.discount_missing': 'Sconto concordato mancante',
  'type.discount_missing.text': 'L\'ordine ha uno sconto che la fattura non applica.',
  'type.payment_terms_differ': 'Termini di pagamento diversi dall\'ordine',
  'type.payment_terms_differ.text': 'I termini in fattura non sono quelli dell\'ordine.',
  'type.totals_dont_add_up': 'I totali non tornano',
  'type.totals_dont_add_up.text': 'Le righe non sommano al totale della fattura.',
  'type.vat_wrong': 'IVA errata',
  'type.vat_wrong.text': 'L\'IVA addebitata non è quella che si applica a questa vendita.',
  'type.bank_details_changed': 'Coordinate bancarie cambiate',
  'type.bank_details_changed.text': 'L\'IBAN in fattura è diverso da quello delle fatture precedenti.',
  'type.price_below_list': 'Prezzo sotto listino',
  'type.price_below_list.text': 'Un prezzo di vendita è sotto il listino.',
};
